import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M17 9.667v1.666m-7.5-7.5H4a2 2 0 0 0-2 2v5.5m0 0V13.5a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-2.167m-15 0h15M18.667 3 14.5 7.167 12.833 5.5"
    }, null, -1)
  ])))
}
export default { render: render }